if (!customElements.get('ss-card-buy')) {
  customElements.define('ss-card-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const card = this.closest('.card-wrapper');
      const image = card?.querySelector('.card__media img');
      const detailsButton = card?.querySelector('.ss-card-details');
      const variantId = this.querySelector('[name=id]')?.value;
      if (detailsButton && variantId) {
        const url = new URL(detailsButton.dataset.productUrl, document.baseURI);
        url.searchParams.set('variant', variantId);
        detailsButton.dataset.productUrl = url.pathname + url.search;
      }
      if (image && this.dataset.variantImage) {
        image.removeAttribute('srcset');
        image.src = this.dataset.variantImage;
      }
    }
  });
}

